
import React, { useEffect, useState, useRef } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import 'chart.js/auto'; //fix: Canvas is already in use. Chart with ID '0' must be destroyed before the canvas can be reused.
import {Bar, Doughnut, Pie} from 'react-chartjs-2'
import ScoreBar from '../../generic/ScoreBar';
import SentimentBar from '../../generic/SentimentBar/SentimentBar';
import { RatingChartConfig, TextChartConfig } from '../../../classes/ChartConfig';
import { IQuestion } from '../../../classes/Question';
import Table from 'react-bootstrap/Table';
import { ProgressBar } from 'react-bootstrap';
import Grid from '@mui/material/Grid';
import { MyMatrix, MyProgressBar } from '../../../../helpers/funtionsUtils/funtionsUtils';
import { experimentalStyled as styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Chart, { ChartConfiguration, ChartTypeRegistry,Color } from 'chart.js/auto';
import { MatrixDataPoint } from 'chartjs-chart-matrix';
import {draw, generate} from 'patternomaly';
import { SurveyService } from '../../../services/SurveyService';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
);
const Item = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'auto',
}));


export const choiceQuestionRender = (index: number, question: IQuestion): React.ReactNode => {
  console.log("*** entra choiceQuestionRender");  
  let chartConfig = new RatingChartConfig(question);
    let { options, data } = chartConfig.createChartConfig();
    
    // Check if this is an eNPS question
    const isENPS = question.title === "How likely is it that you would recommend this company to a friend or colleague?";
    // Check if this is Employee Burnout survey
    const isEmployeeBurnout = question.surveyTitle === "Employee Burnout";
    console.log("[QuestionRender] Question:", question.title, "surveyTitle:", question.surveyTitle, "isEmployeeBurnout:", isEmployeeBurnout);
    
    // options.plugins = {legend: {display: false},tooltip: {
    //         callbacks: {
    //             title: () => '',
    //         }
    //     }};
    
    // Guardar los labels originales para tooltips
    const originalLabels = data.labels || [];
    
    // Crear función de tooltip externo HTML
    const getOrCreateTooltip = (chart: any) => {
        let tooltipEl = chart.canvas.parentNode.querySelector('div.chartjs-tooltip');

        if (!tooltipEl) {
            tooltipEl = document.createElement('div');
            tooltipEl.className = 'chartjs-tooltip';
            tooltipEl.style.background = 'rgba(0, 0, 0, 0.8)';
            tooltipEl.style.borderRadius = '6px';
            tooltipEl.style.color = 'white';
            tooltipEl.style.opacity = '1';
            tooltipEl.style.pointerEvents = 'none';
            tooltipEl.style.position = 'absolute';
            tooltipEl.style.transform = 'translate(-50%, 0)';
            tooltipEl.style.transition = 'all .1s ease';
            tooltipEl.style.padding = '8px 12px';
            tooltipEl.style.fontSize = '11px';
            tooltipEl.style.zIndex = '9999';
            tooltipEl.style.maxWidth = '400px';
            tooltipEl.style.wordWrap = 'break-word';

            const table = document.createElement('table');
            table.style.margin = '0px';
            tooltipEl.appendChild(table);
            chart.canvas.parentNode.appendChild(tooltipEl);
        }

        return tooltipEl;
    };

    const externalTooltipHandler = (context: any) => {
        const {chart, tooltip} = context;
        const tooltipEl = getOrCreateTooltip(chart);

        if (tooltip.opacity === 0) {
            tooltipEl.style.opacity = '0';
            return;
        }

        if (tooltip.body) {
            const titleLines = tooltip.title || [];
            const bodyLines = tooltip.body.map((b: any) => b.lines);

            const tableHead = document.createElement('thead');
            titleLines.forEach((title: string) => {
                const tr = document.createElement('tr');
                tr.style.borderWidth = '0';
                const th = document.createElement('th');
                th.style.borderWidth = '0';
                th.style.paddingBottom = '5px';
                th.style.fontWeight = 'bold';
                const text = document.createTextNode(title);
                th.appendChild(text);
                tr.appendChild(th);
                tableHead.appendChild(tr);
            });

            const tableBody = document.createElement('tbody');
            bodyLines.forEach((body: any, i: number) => {
                const tr = document.createElement('tr');
                tr.style.backgroundColor = 'inherit';
                tr.style.borderWidth = '0';
                const td = document.createElement('td');
                td.style.borderWidth = '0';
                const text = document.createTextNode(body);
                td.appendChild(text);
                tr.appendChild(td);
                tableBody.appendChild(tr);
            });

            const tableRoot = tooltipEl.querySelector('table');
            while (tableRoot.firstChild) {
                tableRoot.firstChild.remove();
            }
            tableRoot.appendChild(tableHead);
            tableRoot.appendChild(tableBody);
        }

        const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
        tooltipEl.style.opacity = '1';
        tooltipEl.style.left = positionX + tooltip.caretX + 'px';
        tooltipEl.style.top = positionY + tooltip.caretY + 'px';
        tooltipEl.style.font = tooltip.options.bodyFont.string;
    };
    
    options.plugins = {
        legend: {display: false},
        tooltip: {
            enabled: false, // Deshabilitar el tooltip de canvas
            position: 'nearest',
            external: externalTooltipHandler,
            callbacks: {
                title: function(context: any) {
                    // Mostrar el texto completo original
                    const index = context[0].dataIndex;
                    return originalLabels[index] || '';
                },
                label: function(context: any) {
                    // Para Pie/Doughnut, el valor está en context.parsed directamente
                    // Para Bar/Line, está en context.parsed.y o context.parsed.x
                    const value = typeof context.parsed === 'number' 
                        ? context.parsed 
                        : (context.parsed.y !== undefined ? context.parsed.y : context.parsed.x);
                    return `Respuestas: ${value}`;
                }
            }
        },
        datalabels: {
            anchor: 'center',    // Posiciona la etiqueta arriba de la barra
            align: 'center',     // Alineación del texto
            color: 'black',   // Color del texto
            formatter: (value: any) => value // Muestra el valor numérico
        }
    };
    options.maintainAspectRatio = false;

    // Create a separate options object for the Pie chart to show percentages
    const pieOptions = {
        ...options,
        scales: {
            x: {
                display: false
            },
            y: {
                display: false
            }
        },
        plugins: {
            ...options.plugins,
            datalabels: {
                ...options.plugins?.datalabels,
                color: 'white', // Better visibility on colored slices
                formatter: (value: number, context: any) => {
                    const dataPoints = context.chart.data.datasets[0].data;
                    const total = dataPoints.reduce((sum: number, dataPoint: number) => sum + dataPoint, 0);
                    if (value === 0) return ''; // Don't show label for 0 value slices
                    if (total === 0) return '0%';
                    const percentage = (value / total) * 100;
                    return `${percentage.toFixed(0)}%`;
                }
            }
        }
    };

    console.log("this optiones : ",options);
    console.log("*** antes return  choiceQuestionRender");  
    return (
      <Item>
        <h3 style={{ 
          fontFamily: "'IBM Plex Sans', sans-serif",
          fontSize: window.innerWidth < 768 ? '14px' : '18px',
          color: '#1A237E',
          fontWeight: '500',
          marginBottom: window.innerWidth < 768 ? '12px' : '16px',
          marginTop: '0',
          lineHeight: '1.4'
        }}>
          {index}. {question.title}
        </h3>
        <Grid container spacing={2} alignItems="center" justifyContent="center">
            <Grid item xs={12} md={isENPS || isEmployeeBurnout ? 12 : 6}>
              <div style={{ position: 'relative', height: '280px', maxWidth: '900px', paddingTop: '10px', margin: '0 auto', overflow: 'visible' }}>
                <Bar options={options} data={data}/>
                {isENPS && (
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    marginTop: '8px',
                    paddingLeft: '40px',
                    paddingRight: '20px',
                    fontSize: '0.75rem',
                    color: '#666'
                  }}>
                    <span>Not at all likely</span>
                    <span>Extremely likely</span>
                  </div>
                )}
              </div>
            </Grid>
            {!isENPS && !isEmployeeBurnout && (
              <Grid item xs={12} md={6}>
                <div style={{ position: 'relative', height: '280px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Pie options={pieOptions} data={data}/>
                </div>
              </Grid>
            )}
          </Grid>
        </Item>
    );
    /*
    return (
        <>
        <Item2>
        <div className="flex flex-wrap">
                {index}. {question.title}
                <div className="container-deducer">
                  <Bar options={options} data={data} />
                </div>
            </div>
        </Item2>
        </>
    );*/
}

export const textQuestionRender = (index: number, question: IQuestion): React.ReactNode => {
    console.log("data textQuestionRender: ",question);
    const chartConfig = new TextChartConfig(question);
    const { options, data } = chartConfig.createChartConfig();
    
    // Calculate average sentiment score and convert to percentage
    const avgSentiment = question.textQuestionProps?.sentimentScores 
        ? question.textQuestionProps.sentimentScores.reduce((sum, score) => sum + score, 0) / question.textQuestionProps.sentimentScores.length
        : 0;
    const sentimentPercentage = Math.round(avgSentiment * 100);
    
    // Determine dominant sentiment
    const dominantSentiment = avgSentiment > 0.33 ? (avgSentiment > 0.66 ? "POSITIVE" : "NEUTRAL") : "NEGATIVE";
    const dominantColor = avgSentiment > 0.33 ? (avgSentiment > 0.66 ? "#6DAE43" : "#FDD835") : "#FB5523";
    
    // Configure doughnut to show percentage inside the ring
    const doughnutOptions = {
        ...options,
        plugins: {
            ...options.plugins,
            tooltip: {
                enabled: true
            },
            datalabels: {
                color: 'white',
                font: {
                    weight: 'bold' as const,
                    size: 18
                },
                formatter: (value: number, context: any) => {
                    const dataPoints = context.chart.data.datasets[0].data;
                    const total = dataPoints.reduce((sum: number, dataPoint: number) => sum + dataPoint, 0);
                    if (value === 0 || total === 0) return '';
                    const percentage = (value / total) * 100;
                    return `${sentimentPercentage}%`;
                }
            }
        }
    };
    
    const containerStyle = {
        display: 'flex',
        justifyContent: 'center'
    };

    const Item = styled(Box)(({ theme }) => ({
        width: '100%',
    }));

    return (
        <>
        <Grid container spacing={2}>
            <Grid item xs={12} md={9}>
            
            <Item>
                
                <h3 style={{
                  fontFamily: "'IBM Plex Sans', sans-serif",
                  fontSize: window.innerWidth < 768 ? '14px' : '18px',
                  color: '#1A237E',
                  fontWeight: '500',
                  lineHeight: '1.4'
                }}>{index}. {question.title}</h3>
                <Table striped bordered hover className='w-100'>
                    <thead>
                    <tr>
                        <th>Answers</th>
                        <th>Sentiment</th>
                    </tr>
                    </thead>
                    <tbody>
                    {question.textQuestionProps?.answers.map((answer, index) => {
                        let sentiment = 0;
                        if (question.textQuestionProps) {
                        sentiment = question.textQuestionProps.sentimentScores[index];
                        }
                        // Use the same color scale as eNPS: orange, yellow, green
                        const backgroundColor = sentiment > 0.33 ? (sentiment > 0.66 ? "#6DAE43" : "#FDD835") : "#FB5523";
                        const label = sentiment > 0.33 ? (sentiment > 0.66 ? "Positive" : "Neutral") : "Negative";
                        
                        return (
                        <tr key={index}>
                            <td className="height-plus">{answer}</td>
                            <td style={{ textAlign: 'center' }}>
                            <span style={{ 
                                display: 'inline-block',
                                backgroundColor: backgroundColor, 
                                color: 'white',
                                padding: '4px 12px',
                                borderRadius: '4px',
                                fontSize: '0.8rem'
                            }}>
                                {label}
                            </span>
                            </td>
                        </tr>
                        );
                    })}
                    </tbody>
                </Table>
                
            </Item>
            </Grid>
            <Grid item xs={12} md={3}>
            <Item>
                    <h3>Satisfaction</h3>
                    <p>Team feelings</p>
                    <Doughnut options={doughnutOptions} data={data} />
                    <br />
                    <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', marginTop: '16px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#FB5523', borderRadius: '2px' }}></div>
                            <span style={{ fontSize: '0.75rem' }}>Negative</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#FDD835', borderRadius: '2px' }}></div>
                            <span style={{ fontSize: '0.75rem' }}>Neutral</span>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <div style={{ width: '12px', height: '12px', backgroundColor: '#6DAE43', borderRadius: '2px' }}></div>
                            <span style={{ fontSize: '0.75rem' }}>Positive</span>
                        </div>
                    </div>                        
                
                </Item>
            </Grid>
        </Grid>
        </>
    )
}
///**** matrix */
interface RawData {
    x: number;
    y: number;
    v: number;
}

const formatData = (responses : any, questions : any, title : string)=>{
  console.log("format data response: ",responses);
  console.log("format data questions: ",questions);
  console.log("format data title: ",title);
  console.log("format data questions.native_question: ",questions.native_questions);
  let data = [{x:1,y:2,valor:30},{x:1,y:2,valor:30},{x:1,y:2,valor:30},{x:1,y:2,valor:30}];

  const rowTitles: string[] = [];
  const columnTitles: string[] = [];
  try {
    let idQuestionCurrent = 0;
    ///obtain id question
    for(const nativeQuestions of questions.native_questions) {
      if(nativeQuestions.content) {
        if(nativeQuestions.content === title) {
          idQuestionCurrent = nativeQuestions.id;
        }
      } else {
        if(nativeQuestions.name === title) {
          idQuestionCurrent = nativeQuestions.id;
        }
      }
      //if( nativeQuestions.name === title) {
      //  idQuestionCurrent = nativeQuestions.id;
     // }
    }
    console.log("format data questions.json.pages: ",questions.json.pages);
    ///obtain quetsions of rows
    for(const jsonPages of questions.json.pages) {
      console.log("jsonPages: ",jsonPages);
      for(const questionPageCurrent of jsonPages.elements) {
        console.log("page Current name:",questionPageCurrent);
        let inOk = false;
        if(questionPageCurrent.title) {
          if(questionPageCurrent.title === title) {
            inOk = true;
          }
        } else {
          if(questionPageCurrent.name === title) {
            inOk = true
          }
        }
        if( inOk ) {
          console.log("entra if questionPageCurrent.name === title:",questionPageCurrent);
          for(const valueRowCurrent of questionPageCurrent.rows) {
            if(valueRowCurrent.text) {
              rowTitles.push( valueRowCurrent.text );
            } else {
              rowTitles.push( valueRowCurrent );
            }
          }
          for(const valueColumnsCurrent of questionPageCurrent.columns) {
            if( valueColumnsCurrent.text ) {
              columnTitles.push( valueColumnsCurrent.text );
            } else {
              columnTitles.push( valueColumnsCurrent );
            }
          }
        }
      }
    }

    console.log("otro paso title: ",title);
    console.log("otro paso responses: ",responses);
    console.log("idQuestionCurrent: ",idQuestionCurrent)
    const matrixMap = new Map<string, Map<string, number>>();
    for(const responseCurrent of responses.native_responses) {
      if(responseCurrent.nativeQuestionId === idQuestionCurrent) {
        const row = responseCurrent.contentQuestion;
        const column = responseCurrent.contentValue;
        const rowMap = matrixMap.get(row) ?? new Map<string, number>();
        const currentValue = rowMap.get(column) ?? 0;
        rowMap.set(column, currentValue + 1);
        matrixMap.set(row, rowMap);
      }
    }
    console.log("mapa es: ", matrixMap);

    data = [];
    console.log("rowTitles: ",rowTitles)
    console.log("columnTitles: ",columnTitles)

    for(const rowCurrent of rowTitles) {
      const rowMap = matrixMap.get(rowCurrent) ?? new Map<string, number>();
      for(const columnCurrent of columnTitles) {
        console.log("1: rowCurrent", rowCurrent, "columCurrent:", columnCurrent);
        console.log("value map: ", rowMap.get(columnCurrent));
        data.push({x: 0, y: 0, valor: rowMap.get(columnCurrent) ?? 0});
      }
    }

    console.log("rowTitles: ",rowTitles);
    console.log("columnTitles: ",columnTitles);
    console.log("idQuestionCurrent:",idQuestionCurrent);
    console.log("data:",data);
    return {
      data:data,
      rowTitles:rowTitles,
      columnTitles:columnTitles,
    };
  } catch (error){
    console.log("error try cathc funtion formatData: ",error);
    data = [
      { x: 1, y: 1, valor: 11 },
    ];
    return {data:data,rowTitles:["h"],columnTitles:["a"]};
  } finally {
    console.log("entra finally");
  }
 
}
const ObtainMatrizFinal = ({ id, index, title }:any) => {
  console.log("type id:", id);
  console.log("obationMatriFinal llega title:",title);
  const [responses, setResponses] = useState({});
  const [questions, setQuestions] = useState({});
  //const [data, setData] = useState<{ x: number; y: number; valor: number }[]>([]);
  useEffect(() => {
    if (id) {
          (async () => {
              //console.log(" ******* props.user in effect: ");
              setResponses(await SurveyService.getSingleSurveyWithResponse(id) );
              setQuestions(await SurveyService.getSingleSurveyFull(id) );
              
            })();
            //setData(formatData(response, questions, title));
      }
    }, [])
    //console.log("index:",index);
    console.log("index, ObtainMatrizFinal response:", responses);
    console.log("index, ObtainMatrizFinal questions:", questions);
//const  rowTitles = ['Aas','B','C'];
//const columnTitles = ["a","b","fa","asd"];
    const {data, rowTitles, columnTitles} = (formatData(responses, questions, title));
//console.log("afuera: ",columnTitles);
console.log("enra Matrix questionRender: ");
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '40vh' }}>
    <MyMatrix 
          numRows={rowTitles.length} 
          numCols={columnTitles.length} 
          maxWidth={250} 
          maxHeight={150} 
          title={title} 
          data={data} 
          color={'00CC00'} 
          rowTitles={rowTitles} 
          columnTitles={columnTitles}
      />
      </div>
  );
}


export const matrixQuestionRender = (index: number, question: IQuestion): React.ReactNode => {
  
  console.log("antes matrix datos index:",index);
  console.log("antes matrix datos question:",question);
  console.log("antes matrix datos title", question.title, typeof question.title)
    return (
       <>
       {/* <Matrix4 data={data}/> */}
        {/* <Matrtix2/> */}
        {/* <MatrixChart data={data}/> */}
       {/* <MatrixChartJS data={data}/> */}
          <ObtainMatrizFinal id={question.surveyId} index={index} title={question.title}/>
       </>
    )
};
  

export const choiceQuestionShowResults = (question: IQuestion): React.ReactNode => {
    console.log("question 1: ",question);
    if( Number.isNaN(question.score)) {
        question.score = 0;
    }
    return (
        <>
            <ScoreBar score={question.score} maxScore={question.maxScore}/>
        </>
    )
}

export const textQuestionShowResults = (question: IQuestion): React.ReactNode => {
    console.log("question 2: ",question);
    return (
        <>
            <SentimentBar score={question.score} />
        </>
    )
}